export const CREATE_CIRCULAR_REQUEST = "CREATE_CIRCULAR_REQUEST";
export const CREATE_CIRCULAR_SUCCESS = "CREATE_CIRCULAR_SUCCESS";
export const CREATE_CIRCULAR_FAILURE = "CREATE_CIRCULAR_FAILURE";
